import React, { useState } from "react";
import { useForm } from "react-hook-form";

const ForeignCurrencyAccounts = ({ onChange, data = [], view = false }) => {
  const {
    register,
    handleSubmit,
    reset,
  } = useForm();

  const [foreignCurrencyList, setForeignCurrencyList] = useState(data);

  const onSubmit = (data) => {
    let obj = [...foreignCurrencyList];
    obj.push(data);
    setForeignCurrencyList(obj);
    onChange(obj);
    reset();
  };

  const handleDelete = (key) => {
    let obj = [...foreignCurrencyList];
    obj.splice(key, 1);
    setForeignCurrencyList(obj);
    onChange(obj);
  };

  return (
    <div>
      <form key={"foreignCurrency"} autocomplete="off">
        <div className="card-header mt-3">
          Identificación de asociados o accionistas, aporte o participación (si
          requiere más espacio anexe relación)
        </div>
        <div className="table-responsive">
          <table class="table table-bordered mt-3">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Tipo de producto</th>
                <th scope="col">Identificación del producto</th>
                <th scope="col">Número del producto</th>
                <th scope="col">Entidad</th>
                <th scope="col">Ciudad</th>
                <th scope="col">País</th>
                <th scope="col">Moneda</th>
                {!view && <th scope="col"></th>}
              </tr>
            </thead>
            <tbody>
              {foreignCurrencyList && foreignCurrencyList.length > 0 ? (
                foreignCurrencyList.map((ele, key) => (
                  <>
                    <tr>
                      <td>{key + 1}</td>
                      <td>{ele.tipo_producto}</td>
                      <td>{ele.identificacion_producto}</td>
                      <td>{ele.numero_producto}</td>
                      <td>{ele.entidad_producto}</td>
                      <td>{ele.ciudad_producto}</td>
                      <td>{ele.pais_producto}</td>
                      <td>{ele.moneda_producto}</td>
                      {!view && (
                        <td>
                          <button
                            className="btn btn-danger btn-sm"
                            type="button"
                            onClick={(e) => handleDelete(key)}
                          >
                            <i className="fas fa-times-circle fa-xs"></i>
                          </button>
                        </td>
                      )}
                    </tr>
                  </>
                ))
              ) : (
                <>
                  <tr>
                    <td
                      className="text-center"
                      scope="col"
                      colspan={view ? 8 : 9}
                    >
                      <span>No record found.</span>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
        {!view && (
          <>
            <div class="row mt-3">
              <div className="form-group col-md-3">
                <label className="form-label"> Tipo de producto </label>
                <input
                  type="text"
                  onInput={(e) =>
                    (e.target.value = ("" + e.target.value).toUpperCase())
                  }
                  style={{ textTransform: "uppercase" }}
                  className="form-control form-control-user"
                  name="tipo_producto"
                  {...register("tipo_producto", { required: true })}
                />
              </div>
              <div className="form-group col-md-3">
                <label className="form-label">
                  {" "}
                  Identificación del producto{" "}
                </label>
                <input
                  type="text"
                  onInput={(e) =>
                    (e.target.value = ("" + e.target.value).toUpperCase())
                  }
                  style={{ textTransform: "uppercase" }}
                  className="form-control form-control-user"
                  name="identificacion_producto"
                  {...register("identificacion_producto", { required: true })}
                />
              </div>
              <div className="form-group col-md-3">
                <label className="form-label"> Número del producto </label>
                <input
                  type="text"
                  onInput={(e) =>
                    (e.target.value = ("" + e.target.value).toUpperCase())
                  }
                  style={{ textTransform: "uppercase" }}
                  className="form-control form-control-user"
                  name="numero_producto"
                  {...register("numero_producto", { required: true })}
                />
              </div>
              <div className="form-group col-md-3">
                <label className="form-label"> Entidad </label>
                <input
                  type="text"
                  onInput={(e) =>
                    (e.target.value = ("" + e.target.value).toUpperCase())
                  }
                  style={{ textTransform: "uppercase" }}
                  className="form-control form-control-user"
                  name="entidad_producto"
                  {...register("entidad_producto", { required: true })}
                />
              </div>
              <div className="form-group col-md-3">
                <label className="form-label"> Ciudad </label>
                <input
                  type="text"
                  onInput={(e) =>
                    (e.target.value = ("" + e.target.value).toUpperCase())
                  }
                  style={{ textTransform: "uppercase" }}
                  className="form-control form-control-user"
                  name="ciudad_producto"
                  {...register("ciudad_producto", { required: true })}
                />
              </div>
              <div className="form-group col-md-3">
                <label className="form-label"> País </label>
                <input
                  type="text"
                  onInput={(e) =>
                    (e.target.value = ("" + e.target.value).toUpperCase())
                  }
                  style={{ textTransform: "uppercase" }}
                  className="form-control form-control-user"
                  name="pais_producto"
                  {...register("pais_producto", { required: true })}
                />
              </div>
              <div className="form-group col-md-3">
                <label className="form-label"> Moneda </label>
                <input
                  type="text"
                  onInput={(e) =>
                    (e.target.value = ("" + e.target.value).toUpperCase())
                  }
                  style={{ textTransform: "uppercase" }}
                  className="form-control form-control-user"
                  name="moneda_producto"
                  {...register("moneda_producto", { required: true })}
                />
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary"
                onClick={handleSubmit(onSubmit)}
              >
                Agregar
              </button>
            </div>
          </>
        )}
      </form>
    </div>
  );
};

export default ForeignCurrencyAccounts;
